import { findBoolean, User, UserStatus } from '@repo-level/core-front';
import { curry, equals, map, pipe, prop, propOr } from 'ramda';

export enum USER_GROUP {
  DEPOSITOR = 'DEP',
  ONE_OR_MORE_DEP = 'DEP>0',
  WELCOME_PACKAGE = 'WP',
  SIGN_UPS = '00011',
  VIP = 'VIP',
  GOLD = 'VIP1',
  PLATINUM = 'VIP2',
  DIAMOND = 'VIP3',
  BA = 'BA',
  BR = 'BR',
  LA = 'LA',
  BR2 = 'BR2',
  ACTIVE_BONUS = 'ACTBONUS',
  NO_KYC = 'NO_KYC',
  VERIFIED = 'Tag_Verified',
  DEV_TEST = 'DevTest', //group for QA
  ASKED_FOR_DOCS = 'asked_docs',
  VIPBA = 'VIPBA',
  LOYALS = 'Loyals',
  CHAMPIONS = 'Champions',
  PVIP = 'PVIP',
  SDR_COMPLETE = 'SDR_COMPLETE',
  FIAT_PLAYERS = 'FiatPlayers',
  DUPLICATE = 'Duplicate',
}

export const COMMON_VIP_GROUPS = [
  USER_GROUP.GOLD,
  USER_GROUP.PLATINUM,
  USER_GROUP.DIAMOND,
];

export const vipGroups = [...COMMON_VIP_GROUPS, USER_GROUP.PVIP];

export const DEFAULT_NEW_USER_GROUPS = [
  { name: 'WPE', id: USER_GROUP.WELCOME_PACKAGE },
  { name: 'Sign-ups', id: USER_GROUP.SIGN_UPS },
];

export const BONUS_RESTRICTED_GROUPS = [{ name: 'BR', id: USER_GROUP.BR }];

export const bonusRestrictedGroups = [USER_GROUP.BA, USER_GROUP.BR];

export const BonanzaRestrictedGroups = [
  ...bonusRestrictedGroups,
  USER_GROUP.VIPBA,
];

export const groupMember = (groupId: string) =>
  pipe<User | undefined, UserStatus[], UserStatus['id'][], boolean>(
    propOr<UserStatus[]>([], 'statuses'),
    map(prop('id')),
    findBoolean(equals(groupId))
  );

export const everyGroupMember = (groupId: string[]) => (
  user: User | undefined
) => map((id) => groupMember(id)(user), groupId).every((v) => !!v);

export const someGroupMember = (groupId: string[]) => (
  user: User | undefined
) => map((id) => groupMember(id)(user), groupId).some((v) => !!v);

export const groupMemberDepositor = someGroupMember([USER_GROUP.DEPOSITOR]);

export const groupMemberOneOrMoreDep = someGroupMember([
  USER_GROUP.ONE_OR_MORE_DEP,
]);

export const groupMemberNoDeposits = groupMember(USER_GROUP.SIGN_UPS);

export const groupMemberVip = someGroupMember([USER_GROUP.VIP]);

export const groupMemberGOLD = groupMember(USER_GROUP.GOLD);

export const groupMemberPLATINUM = groupMember(USER_GROUP.PLATINUM);

export const groupMemberDIAMOND = groupMember(USER_GROUP.DIAMOND);

export const groupMemberBA = groupMember(USER_GROUP.BA);

export const groupMemberBR = groupMember(USER_GROUP.BR);

export const groupMemberLA = groupMember(USER_GROUP.LA);

export const groupMemberActiveBonus = groupMember(USER_GROUP.ACTIVE_BONUS);

export const groupMemberNoKYC = groupMember(USER_GROUP.NO_KYC);

export const groupMemberVerified = groupMember(USER_GROUP.VERIFIED);

export const groupMemberAskedForDocs = groupMember(USER_GROUP.ASKED_FOR_DOCS);

export const groupMemberFiatPlayers = groupMember(USER_GROUP.FIAT_PLAYERS);

export const groupMemberDuplicate = groupMember(USER_GROUP.DUPLICATE);

export const pickGroupsCurried = curry(
  (vipGroups: USER_GROUP[], user: User | undefined) =>
    vipGroups.filter((group) => groupMember(group)(user))
);

export const pickVipGroupsCurried = pickGroupsCurried(COMMON_VIP_GROUPS);
